<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme">
      <div class="info">
        <div class="sub-total">
          <div class="item-title" >{{$t('crm_contract_change_rent.xzxzzsb')}}</div>
          <div class="pay-info" v-if="Object.keys(schemeInfo).length">
            <!--
              甲方代表 总部一样 显示总部应收  显示 总部应收，金额取 甲方授权代表应收金额
              甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收。
              总部为售后服务公司时，售后公司应收的金额 需累计总部应收中
            -->
            <div v-if="contractInfo.partyAId !== contractInfo.hqId">
              {{ $t('crm_contract_change_rent.jfsqdbys') }}：
              <span>{{ schemeInfo.firstTotal }}</span>
            </div>
            <div>
              {{ $t('crm_contract_change_rent.zong_bu_ying_shou') }}:
              <span v-if="contractInfo.partyAId === contractInfo.hqId&&contractInfo.hqId !== contractInfo.afterServiceId">{{ schemeInfo.firstTotal }}</span>
              <span v-else-if="contractInfo.partyAId !== contractInfo.hqId && contractInfo.hqId === contractInfo.afterServiceId">{{ parseFloat((schemeInfo.hqProfitTotal + schemeInfo.serviceProfitTotal).toFixed(2))  }}</span>
              <span v-else-if="contractInfo.partyAId === contractInfo.hqId && contractInfo.hqId === contractInfo.afterServiceId">{{  schemeInfo.firstTotal }}</span>
              <span v-else>{{ schemeInfo.hqProfitTotal }}</span>
            </div>
            <div v-if="contractInfo.partyAId !== contractInfo.afterServiceId&& contractInfo.hqId !== contractInfo.afterServiceId">
              {{ $t('crm_contract_change_rent.shou_hou_ying_shou') }}：
              <span>{{ schemeInfo.serviceProfitTotal }}</span>
            </div>
          </div>
        </div>
        <div class="table-bd">
          <custom-table
            tableCode="testToRent"
            ref="customTb1"
            :data="dataList"
            @sort="sortChange"
            @filter="filterChange"
            type="checkbox"
            v-model="selectRows"
            :expand="true"
            :default-expand-all="true"
            :slots="['action']"
            selectableKey="selectableKey"
          >
              <template slot="expand" slot-scope="scope">
              <div class="tab-wrap">
                <el-form label-position="top" class="wrap-form">
                  <el-row :gutter="15" class="wrap-form-row">
                    <template v-if="scope.row.edit">
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.zu_jin_yue')" prop="unitPrice">
                          {{ scope.row.currencyUnit }}
                          {{ scope.row.unitPrice }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item
                          :label="$t('crm_contract_change_rent.shfjfy')"
                          prop="additionalFee"
                        >
                          <el-input
                            v-model="scope.row.additionalFee"
                            style="width: 66%"
                          >
                            <template slot="prepend">{{
                              scope.row.currencyUnit
                            }}</template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.fu_kuan_qi_shu')">
                          {{ computedNum(scope.row, 'periodNum') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.sqfcfa')">
                          {{ scope.row.sharingClass}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.shou_qi_zu_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ computedNum(scope.row, 'firstRent') }}
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="4"
                      >
                        <el-form-item
                          :label="$t('crm_contract_change_rent.lei_ji_zu_jin_tai')"
                          style="cursor: pointer"
                        >
                          {{ scope.row.currencyUnit }}
                          {{ computedNum(scope.row, 'totalRent') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.she_bei_shu_liang')">
                          {{ scope.row.bookingNum }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item :label="$t('crm_contract_change_rent.ya_jin_tai')">
                          <el-input
                            v-model="scope.row.depositFee"
                            placeholder
                            style="width: 66%"
                          >
                            <template slot="prepend">
                              {{ scope.row.currencyUnit }}</template
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4" v-if="!form.lastOrderId">
                        <!--2021-09-02 期末续租不需要设总部发货收货方 -->
                        <el-form-item :label="$t('crm_contract_change_rent.zbfhshf')">
                          <custom-select disabled v-model="scope.row.hqShipTo" code="crm_receiving_party" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="4">
                        <el-form-item :label="$t('Common.com_handle')">
                          <el-button type="text" size="mini" v-if="!scope.row.edit" @click="editItem(scope.row)">{{ $t('Common.com_edit') }}</el-button>
                          <el-button type="text" size="mini" v-if="scope.row.edit" @click="saveItem(scope.row,'saveDevice')">{{ $t('Common.com_save') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </template>
                    <template v-else>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.zu_jin_yue')" prop="unitPrice">
                          {{ scope.row.currencyUnit }}
                          {{ scope.row.unitPrice }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item
                          :label="$t('crm_contract_change_rent.shfjfy')"
                          prop="additionalFee"
                        >
                        {{ scope.row.currencyUnit }}
                        {{ scope.row.additionalFee }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.fu_kuan_qi_shu')">
                          {{ computedNum(scope.row, 'periodNum') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.sqfcfa')">
                          {{ scope.row.sharingClass}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.shou_qi_zu_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ computedNum(scope.row, 'firstRent') }}
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="4"
                      >
                        <el-form-item
                          :label="$t('crm_contract_change_rent.lei_ji_zu_jin_tai')"
                          style="cursor: pointer"
                        >
                          {{ scope.row.currencyUnit }}
                          {{ computedNum(scope.row, 'totalRent') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_rent.she_bei_shu_liang')">
                          {{ scope.row.bookingNum }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item :label="$t('crm_contract_change_rent.ya_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ scope.row.depositFee }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4" v-if="!form.lastOrderId">
                        <!--2021-09-02 期末续租不需要设总部发货收货方 -->
                        <el-form-item :label="$t('crm_contract_change_rent.zbfhshf')">
                          <custom-select disabled v-model="scope.row.hqShipTo" code="crm_receiving_party" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="4">
                        <el-form-item :label="$t('Common.com_handle')">
                          <el-button type="text" size="mini" v-if="!scope.row.edit" @click="editItem(scope.row)">{{ $t('Common.com_edit') }}</el-button>
                          <el-button type="text" size="mini" v-if="scope.row.edit" @click="saveItem(scope.row,'saveDevice')">{{ $t('Common.com_save') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </template>
                  </el-row>
                </el-form>
                <ul class="rent-amount">
                  <li>
                    <p class="titel">{{$t('crm_contract_change_rent.sqljzj')}}</p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ computedNum(scope.row, 'firstRentTotal') }}
                    </p>
                  </li>
                  <li>
                    <p class="titel">{{$t('crm_contract_change_rent.lei_ji_ya_jin')}}</p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ computedNum(scope.row, 'depositFeeTotal') }}
                    </p>
                  </li>
                  <li>
                    <p class="titel">{{$t('crm_contract_change_rent.shou_qi_xu_zhi_fu')}}</p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ computedNum(scope.row, 'firstPay') }}
                    </p>
                  </li>
                </ul>
              </div>
            </template>
            <template slot="rentalTerms" slot-scope="scope">
              <el-input
                disabled
                type="number"
                :min="1"
                v-model="scope.row.rentalTerm"
                placeholder
                style="width: 100%"
              >
              </el-input>
            </template>
            <template slot="action" slot-scope="scope">
              <!-- <el-button type="text" @click="addLeaseItem(scope.row)"
                >{{$t('page_content_edit_lease_plan')}}</el-button
              > -->

              <el-button type="text" size="mini" @click="addLeaseItem(scope.row,'date_end_continue')">{{$t('crm_contract_change_rent.xzzlfa')}}</el-button>
              <!-- 更换设备 在库中  才能点更换设备原合同甲方和当前售后一样的时候才能点-->
              <el-button type="text" size="mini"  v-if="`${scope.row.realBizState}`==='12'&&scope.row.partyAId===scope.row.afterServiceId" @click="onReplaceDevice(scope.row)">{{$t('crm_contract_change_rent.geng_huan_she_bei')}}</el-button>
              <el-button type="text" size="mini" v-if="scope.row.goodsSkuId" @click="onPreviewDialog(scope.row)">{{ $t('crm_contract_change_rent.ckfcmx') }}</el-button>
              <el-button type="text" size="mini" v-if="scope.row.goodsSkuId" @click="onPreviewBreakDialog(scope.row)">{{ $t('crm_contract_change_rent.ckwyfa') }}</el-button>
            </template>
          </custom-table>
        </div>
      </div>
      <div class="info" style="margin-top: 24px;">
        <div class="sub-total">
          <div class="item-title">{{$t('crm_contract_change_rent.tjxzlsb')}}</div>
        </div>
        <!-- :default-expand-all="true" -->
        <custom-table tableCode="contract_scheme" v-loading="isLoading" :data="leaseForm.contractList"
          :default-expand-all="true"
          expand
          row-key="goodsSkuId"
          :expand-row-keys="expands"
          :slots="['action']"
        >
          <template slot="expand" slot-scope="scope">
            <div class="tab-wrap">
              <el-form  label-position="top" class="wrap-form">
                <el-row :gutter="15" class="wrap-form-row">

                  <template v-if="scope.row.edit">
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.zu_jin_yue')">
                        {{ scope.row.currencyUnit }}
                        {{ scope.row.unitPrice }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.shfjfy')">
                        <el-input v-model="scope.row.additionalFee" placeholder style="width: 100%">
                          <template slot="prepend">
                            {{ scope.row.currencyUnit }}
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.fu_kuan_qi_shu')">
                        {{ Math.ceil(scope.row.rentalTerm / scope.row.paymentPeriodSlef) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.shou_qi_zu_jin_tai')">
                        {{ scope.row.currencyUnit }}
                        {{ ((parseFloat(scope.row.unitPrice) + parseFloat(scope.row.additionalFee)) * scope.row.paymentPeriodSlef).toFixed(2) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3" @click.native="onPreviewDialog(scope.row)">
                      <el-form-item :label="$t('crm_contract_change_rent.lei_ji_zu_jin_tai')" style="cursor: pointer">
                        {{ scope.row.currencyUnit }}
                        {{ ((parseFloat(scope.row.unitPrice) + parseFloat(scope.row.additionalFee)) * scope.row.rentalTerm).toFixed(2) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.she_bei_shu_liang')">
                        <el-input v-model="scope.row.bookingNum" type="number" min="0" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.ya_jin_tai')">
                        <el-input v-model="scope.row.depositFee" placeholder style="width: 100%">
                          <template slot="prepend">
                            {{ scope.row.currencyUnit }}
                          </template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.xu_zong_bu_fa_huo')">
                        <el-input v-model="scope.row.hqDeliveryNum" type="number" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3" v-if="!form.lastOrderId">
                      <!--2021-09-02 期末续租不需要设总部发货收货方 -->
                      <el-form-item :label="$t('crm_contract_change_rent.zbfhshf')">
                        <custom-select disabled v-model="scope.row.hqShipTo" code="crm_receiving_party" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                      </el-form-item>
                    </el-col>
                  </template>
                  <template v-else>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.zu_jin_yue')">
                        {{ scope.row.currencyUnit }}
                        {{ scope.row.unitPrice }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.shfjfy')">
                        {{ scope.row.currencyUnit }}
                        {{ scope.row.additionalFee }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.fu_kuan_qi_shu')">
                        {{ Math.ceil(scope.row.rentalTerm / scope.row.paymentPeriodSlef) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.shou_qi_zu_jin_tai')">
                        {{ scope.row.currencyUnit }}
                        {{ ((parseFloat(scope.row.unitPrice) + parseFloat(scope.row.additionalFee)) * scope.row.paymentPeriodSlef).toFixed(2) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3" @click.native="onPreviewDialog(scope.row)">
                      <el-form-item :label="$t('crm_contract_change_rent.lei_ji_zu_jin_tai')" style="cursor: pointer">
                        {{ scope.row.currencyUnit }}
                        {{ ((parseFloat(scope.row.unitPrice) + parseFloat(scope.row.additionalFee)) * scope.row.rentalTerm).toFixed(2) }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.she_bei_shu_liang')">
                        {{ scope.row.bookingNum }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.ya_jin_tai')">
                        {{ scope.row.currencyUnit }}
                        {{ scope.row.depositFee }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-form-item :label="$t('crm_contract_change_rent.xu_zong_bu_fa_huo')">
                        {{ scope.row.hqDeliveryNum }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="3" v-if="!form.lastOrderId">
                      <el-form-item :label="$t('crm_contract_change_rent.zbfhshf')">
                        <custom-select disabled v-model="scope.row.hqShipTo" code="crm_receiving_party" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                      </el-form-item>
                    </el-col>
                  </template>
                  <el-col :span="4">
                    <el-form-item :label="$t('Common.com_handle')">
                      <el-button type="text" size="mini" v-if="!scope.row.edit" @click="editItem(scope.row)">{{ $t('Common.com_edit') }}</el-button>
                      <el-button type="text" size="mini" v-if="scope.row.edit" @click="saveItem(scope.row,'savePlan')">{{ $t('Common.com_save') }}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <ul class="rent-amount">
                <li>
                  <p class="titel">
                    {{ $t('crm_contract_change_rent.sqljzj') }}
                  </p>
                  <p class="amount">
                    {{ scope.row.currencyUnit }}
                    <!-- 50,000.00 -->
                    {{ ((parseFloat(scope.row.unitPrice) + parseFloat(scope.row.additionalFee)) * scope.row.paymentPeriodSlef * scope.row.bookingNum).toFixed(2) }}
                  </p>
                </li>
                <li>
                  <p class="titel">
                    {{ $t('crm_contract_change_rent.lei_ji_ya_jin') }}
                  </p>
                  <p class="amount">
                    {{ scope.row.currencyUnit }}
                    {{ (scope.row.depositFee * scope.row.bookingNum).toFixed(2) }}
                  </p>
                </li>
                <li>
                  <p class="titel">
                    {{ $t('crm_contract_change_rent.shou_qi_xu_zhi_fu') }}
                  </p>
                  <p class="amount">
                    {{ scope.row.currencyUnit }}
                    {{
                      (
                        (parseFloat(scope.row.unitPrice) + parseFloat(scope.row.additionalFee)) * scope.row.paymentPeriodSlef * scope.row.bookingNum +
                        scope.row.depositFee * scope.row.bookingNum
                      ).toFixed(2)
                    }}
                  </p>
                </li>
              </ul>
            </div>
          </template>
          <!-- 操作列 -->
          <template slot="action" slot-scope="scope">
            <el-button type="text" size="mini" @click="onRowExpansion(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" @click="deleteLeaseItem(scope.$index, scope.row)">{{ $t('Common.com_delete') }}</el-button>
            <el-button type="text" size="mini" @click="onPreviewDialog(scope.row)">{{ $t('crm_contract_change_rent.ckfcmx') }}</el-button>
            <el-button type="text" size="mini" @click="onPreviewBreakDialog(scope.row)">{{ $t('crm_contract_change_rent.ckwyfa') }}</el-button>
          </template>
        </custom-table>
        <!-- <el-button style="margin: 15px" type="primary" @click="addBenefitSharing()">{{ $t('com_add_to') }}</el-button> -->
      </div>
      <div class="lease-add-btn" @click="addLeaseItem({},'add')">
        <div style="display: inline-block">
          <i class="icon icon-add"></i>
          <span>{{ $t('crm_contract_change_rent.tjsbzlxx') }}</span>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <el-button type="primary" @click="saveScheme('saveALL')">{{$t('crm_contract_change_rent.xybqrhtxx')}}</el-button>
    </div>
    <!-- 选择方案 -->
    <contractManagement-addLease-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="addLeaseList"
    ></contractManagement-addLease-dialog>
     <!-- 查看分成 -->
     <step-manage-preview-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></step-manage-preview-dialog>
    <!-- 查看违约方案 -->
    <step-manage-falsify-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></step-manage-falsify-dialog>
     <!-- 选择设备 -->
     <device-select v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @success="onSelectDevice"></device-select>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import stepManagePreviewDialog from '@/pages/crm/components/managePreviewDialog.vue';
import stepManageFalsifyDialog from '@/pages/crm/contractLeaseItem/children/step_manage_falsify_dialog';
import deviceSelect from '@/pages/crm/components/device_select_dialog.vue';
import contractManagementAddLeaseDialog from './contractManagement_addLease_dialog.vue';

export default {
  components: { contractManagementAddLeaseDialog, stepManagePreviewDialog, stepManageFalsifyDialog, deviceSelect },
  props: {
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number],
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
    // 获取row的key值
    // getRowKeys(row) {
    //   return row.goodsSkuId;
    // },
  },
  watch: {
    'form.lastOrderId': {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDeviceList();
        }
      }
    }
  },
  data() {
    return {
      dataList: [],
      selectRows: [],
      form: {
        bizClass: 22,
        // 20-租赁合同 30-框架合同
        orderType: '',
        bizId: '',
        deviceGoodsList: [],
        lastOrderId: '',
        operateFlag: '',
      },
      schemeInfo: {},
      // 租赁方案
      leaseForm: {
        contractList: [],
        // 删除的
        deleteList: [],
      },
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      expands: [],
    };
  },
  mounted() {
    this.form.lastOrderId = this.getJump('lastOrderId');
    this.form.orderType = this.getJump('orderType');
    // setTimeout(() => {
    //   this.getDeviceList();
    // }, 1000);

  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    // 租赁计算
    computedNum: function (row, name) {
      // 累计押金
      if (name === 'depositFeeTotal') {
        row.depositFeeTotal = (+row.depositFee * +row.bookingNum).toFixed(2);
        return row.depositFeeTotal;
      }
      // 首期租金(合计)
      if (name === 'firstRentTotal') {
        row.firstRentTotal = (
          (parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0))
          * (+row.paymentPeriod || +row.rentalTerm)
          * +row.bookingNum
        ).toFixed(2);
        return row.firstRentTotal;
      }
      // 首期需支付
      if (name === 'firstPay') {
        row.firstPay = (
          (parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0))
            * (+row.paymentPeriod || +row.rentalTerm)
            * +row.bookingNum
          + +row.depositFee * +row.bookingNum
        ).toFixed(2);
        return row.firstPay;
      }
      // 租赁期数
      if (name === 'periodNum') {
        row.periodNum = +row.rentalTerm ? Math.ceil(
          +row.rentalTerm / (+row.paymentPeriod || +row.rentalTerm || 0)
        ) : 0;
        return row.periodNum;
      }
      // 首期租金/台
      if (name === 'firstRent') {
        row.firstRent = (
          (parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0))
          * (+row.paymentPeriod || +row.rentalTerm)
        ).toFixed(2);
        return row.firstRent;
      }
      // 累计租金/台
      if (name === 'totalRent') {
        row.totalRent = (
          (parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0))
          * +row.rentalTerm
        ).toFixed(2);
        return row.totalRent;
      }
      return '';
    },
    // 合同设备列表
    getDeviceList: function () {
      this.$getJSON(apis.trialOrderDeviceToLeaseList, {
        bizState: this.contractInfo.bizState,
        orderId: this.contractId,
        orderType: this.contractInfo.bizState,
        lastOrderId: this.form.lastOrderId,
        // contractChangeType: '',
        // showCurrentPeriod: 0,
        // showDeviceType: 0,

      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.testRentalTerm = item.rentalTerm;
          item.rentalTerm = 1;
          item.bookingNum = 1;
          item.oldRentalTerm = item.rentalTerm;
          item.edit = true;
        });
        this.dataList = list;
        // this.getChangeDetail();
        this.getListSchemeDetail();
      });
    },

    // 合同设备列表详情
    // getChangeDetail: function () {
    //   if (!this.contractId) {
    //     return;
    //   }
    //   this.$getJSON(apis.OrderChangeDeviceList, {
    //     orderId: this.contractId,
    //     showDeviceType: 0,
    //     showCurrentPeriod: 0,
    //   }).then((res) => {
    //     const selectDevice = res.data;
    //     this.dataList.forEach((item) => {
    //       const row = selectDevice.find(
    //         t => t.bodyNum === item.bodyNum
    //       );
    //       if (row) {
    //         this.$setFormatData(item, row);
    //         this.$refs.customTb1.$emit('toggleRowSelection', item, true);
    //       }
    //     });
    //   });
    // },
    // 查询租赁方案
    getListSchemeDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        this.isLoading = false;
        const data = res.data.goodsList ? res.data.goodsList : [];
        const filteredGoodsList = data.reduce((acc, i) => {
          const matchedItem = this.dataList.find(item => item.nextOrderGoodsId === i.orderGoodsId);
          if (!matchedItem) {
            acc.push(i);
          } else {
            const matchedItemIndex = this.dataList.findIndex(item => item.nextOrderGoodsId === i.orderGoodsId);
            this.dataList[matchedItemIndex] = Object.assign(matchedItem, i, { orderGoodsId: matchedItem.orderGoodsId, edit: false });
            // planRentalStartTime   计划启租日期计算规则：原来的设备启租日期中的年月份 < 当前日期年月 则 计划启租日期 为当前年月的1日 否则 计划启租日期=设备启租日期
            if (this.$moment(this.dataList[matchedItemIndex].rentalStartTime).isSame((Date.now(), 'month'))) {
              this.dataList[matchedItemIndex].planRentalStartTime = this.$momentWorld(this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'));
            } else {
              this.dataList[matchedItemIndex].planRentalStartTime = this.dataList[matchedItemIndex].rentalStartTime;
            }
            this.$refs.customTb1.$emit('toggleRowSelection', this.dataList[matchedItemIndex], true);
          }
          i.edit = false;
          i.hqShipTo = i.hqShipTo ? `${i.hqShipTo}` : '2';

          // 如果是一次性付清 0 就改为一期
          if (i.paymentPeriod === '0' || i.paymentPeriod === 0) {
            i.paymentPeriodSlef = i.rentalTerm;
          } else {
            i.paymentPeriodSlef = i.paymentPeriod;
          }
          return acc;
        }, []);
        this.leaseForm.contractList = filteredGoodsList;

        // this.dataList.forEach((good) => {
        //   const matchedItem = data.find(item => good.nextOrderGoodsId === item.orderGoodsId);
        //   if (matchedItem) {
        //     good = Object.assign({}, good, matchedItem);
        //   }
        // });
        // const selectDevice = res.data;
        // this.dataList.forEach((item) => {
        //   const row = selectDevice.find(
        //     t => t.bodyNum === item.bodyNum
        //   );
        //   if (row) {
        //     this.$setFormatData(item, row);
        //     this.$refs.customTb1.$emit('toggleRowSelection', item, true);
        //   }
        // });
        this.schemeInfo = res.data;
      });
    },
    // 选择方案弹窗回调
    addLeaseList: function (list, rentalTerm) {
      // 上面的
      if (this.dialogModel.type === 'date_end_continue') {
        this.dialogModel.row.rentalTerm = rentalTerm;
        this.$setFormatData(this.dialogModel.row, list[0], 'paymentPeriod,additionalFee,depositFee,paymentNode,unitPrice,currencyUnit,sharingList,goodsSkuId,goodsName,goodsSkuOwner');
        // planRentalStartTime   计划启租日期计算规则：原来的设备启租日期中的年月份 < 当前日期年月 则 计划启租日期 为当前年月的1日 否则 计划启租日期=设备启租日期
        if (this.$moment(this.dialogModel.row.rentalStartTime).isSame((Date.now(), 'month'))) {
          this.dialogModel.row.planRentalStartTime = this.$momentWorld(this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'));
        } else {
          this.dialogModel.row.planRentalStartTime = this.dialogModel.row.rentalStartTime;
        }
      } else {
        // 修复数量为空 总额NAN
        list.forEach((i) => {
          if (!i.bookingNum) {
            this.$set(i, 'bookingNum', 1);
            this.$set(i, 'hqDeliveryNum', 0);
            this.$set(i, 'edit', false);
          }
          // 设置月数
          i.rentalTerm = rentalTerm;
          // 发货方默认是乙方
          i.hqShipTo = '2';
          // 如果是一次性付清 0 就改为一期  如果是周期超过租赁月数那就用租赁月数
          if (i.paymentPeriod === '0' || i.paymentPeriod === 0) {
            i.paymentPeriodSlef = i.rentalTerm;
          } else {
            i.paymentPeriodSlef = i.paymentPeriod;
          }
          // 加载回来默认是展开的
          i.edit = true;
        });
        // 去除重叠的型号
        const concatArr = this.leaseForm.contractList.concat(list.filter(item => !this.leaseForm.contractList.find(inItem => inItem.goodsSkuId === item.goodsSkuId)));
        this.leaseForm.contractList = concatArr;
        if (list) {
          this.expands = [];
          this.expands.push(list[0].goodsSkuId);
        }
      }

    },
    // 新增方案弹窗
    addLeaseItem: function (row, type) {
      this.dialogVisible = true;
      this.dialogModel.type = type;
      row.rentalTermUnit = 'M';
      this.dialogModel.row = row;
      this.dialogModel.title = this.$t('crm_contract_change_rent.xzzlfa');
    },
    // 查看分成预览
    onPreviewDialog: function (data) {
      this.dialogModel1.title = this.$t('crm_contract_change_rent.fen_cheng_ming_xi');
      this.dialogModel1.data = { row: data, month: data.rentalTerm };
      this.dialogVisible1 = true;
    },
    // 查看违约方案
    onPreviewBreakDialog(data) {
      this.dialogModel2.type = 'watch';
      this.dialogModel2.title = this.$t('crm_contract_change_rent.ckwyfa');
      this.dialogModel2.data = { row: data };
      this.dialogVisible2 = true;
    },
    // 选择方案弹窗回调
    // 编辑方案
    editItem: function (item) {
      item.edit = true;
    },
    // 选择设备弹窗
    onReplaceDevice: function (row) {
      this.dialogModel3.title = this.$t('crm_contract_change_rent.geng_huan_she_bei');
      this.dialogModel3.row = row;
      this.dialogVisible3 = true;
    },
    onRowExpansion: function (item) {
      this.expands = [];
      this.expands.push(item.goodsSkuId);
      item.edit = true;
    },
    // 删除方案项
    deleteLeaseItem: function (index, row) {
      this.leaseForm.contractList.splice(index, 1);
      this.leaseForm.deleteList.push({ ...row, isDeleted: true });
      this.schemeInfo = {};
    },
    // 保存方案
    saveItem: function (item, type) {
      item.edit = false;
      if (type === 'saveDevice') {
        // 选中
        this.$refs.customTb1.$emit('toggleRowSelection', item, true);
      }

      // if (this.selectRows.length && !this.selectRows.find(row => row.goodsSkuId === item.goodsSkuId)) {
      //   this.selectRows = this.selectRows.psuh(item);
      // }
      // 最后没选择或者没有方案 就只改变当前项的edit 不保存
      // if (type === 'saveDevice'&& !this.selectRows.length && !this.selectRows.find(i => i.goodsSkuId === item.goodsSkuId)) {
      //   return;
      // }

      // this.$nextTick(() => {
      //   this.saveScheme(type);
      // });
      setTimeout(() => {
        this.saveScheme(type);
      }, 300);
    },
    onSelectDevice(row) {
      this.dialogModel3.row.bodyNum = row.bodyNum;
      this.dialogModel3.row.deviceId = row.deviceId;
      this.dialogModel3.row.nextDeviceBizType = row.nextDeviceBizType;
    },
    saveScheme: function (type) {
      // 转租设备验证
      // 只要保存上面就要验证  必选设备的
      // if (type === 'saveALL' || type === 'saveDevice') {
      if (!this.selectRows.length) {
        this.$message.error(this.$t('crm_contract_change_rent.qxzxzsb'));
        return;
      }
      const hasEmpty = this.selectRows.find(
        t => !`${t.rentalTerm}` || !`${t.additionalFee}` || !`${t.depositFee}`
      );
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_change_rent.qjsjtxwz'));
        return;
      }
      const hasEmptyPlan = this.selectRows.find(
        t => !t.goodsSkuId
      );
      if (hasEmptyPlan) {
        this.$message.error(this.$t('crm_contract_change_rent.qxzzlfa'));
        return;
      }
      const unitPriceFree = this.selectRows.find(
        t => t.unitPrice === 0
      );

      if (unitPriceFree) {
        this.$message.error(this.$t('crm_contract_change_rent.qbjzlfazjbnxy0'));
        return;
      }
      this.selectRows.forEach((i) => {
        i.lastOrderDeviceId = i.orderDeviceId;
      });
      // this.form.deviceGoodsList = this.selectRows;

      // }
      // if (type === 'saveALL' || type === 'savePlan') {
      // 租赁方案
      // 方案表单验证
      const hasEmptyRentPlan = this.leaseForm.contractList.find(t => !t.bookingNum === '' || t.hqDeliveryNum === '' || !t.hqShipTo);
      if (hasEmptyRentPlan) {
        this.$message.error(this.$t('crm_contract_change_rent.qjzlfatxwz'));

      }
      // 附加费不能小于0
      const additionalFee = this.leaseForm.contractList.find(t => +t.additionalFee < 0);
      if (additionalFee) {
        this.$message.error(this.$t('crm_contract_change_rent.shfjfbnxy0'));

      }
      const negativeTotal = this.leaseForm.contractList.find(t => +t.bookingNum <= 0);
      if (negativeTotal) {
        this.$message.error(this.$t('crm_contract_change_rent.sbslbnxy0'));

      }
      const negativeShip = this.leaseForm.contractList.find(t => +t.hqDeliveryNum < 0);
      if (negativeShip) {
        this.$message.error(this.$t('crm_contract_change_rent.xzbfhslbnxy0'));

      }
      const hqDeliveryNumBigger = this.leaseForm.contractList.find(t => +t.bookingNum < +t.hqDeliveryNum);
      if (hqDeliveryNumBigger) {
        this.$message.error(this.$t('crm_contract_change_rent.zbfhbxxyzsl'));

      }
      this.leaseForm.contractList.forEach((item) => {
        item.operateFlag = this.operateFlag;
        // 期数
        item.periodNum = Math.ceil(item.rentalTerm / item.paymentPeriodSlef);
        // 组件加附加费
        item.cost = (parseFloat(item.unitPrice, 10) + parseFloat(item.additionalFee, 10)).toFixed(2);
        // 首期租金/台
        item.firstRent = (item.cost * item.paymentPeriodSlef).toFixed(2);
        // 累计租金/台
        item.totalRent = (item.cost * item.rentalTerm).toFixed(2);
        // 首期租金(合计)
        item.firstRentTotal = parseFloat(item.firstRent * item.bookingNum).toFixed(2);
        // 累计押金
        item.depositFeeTotal = parseFloat(item.depositFee * item.bookingNum).toFixed(2);
        // 首期需支付
        item.firstPay = parseFloat(item.firstRentTotal + item.depositFeeTotal).toFixed(2);
        // item.bizClass = this.contractClass;
        // item.bizId = this.contractId;
      });

      this.form.operateFlag = this.operateFlag;
      // , ...this.leaseForm.deleteList
      this.form.deviceGoodsList = [...this.selectRows, ...this.leaseForm.contractList];
      // }
      // return;
      if (!this.contractId) {
        this.addContractRent(type);
      } else {
        this.updateContractRent(type);
      }
    },
    // 试用转租赁新增
    addContractRent: function (type) {
      this.$postJSON(apis.TestToRentAdd, this.form).then((res) => {
        this.$emit('syncContractId', res.data, 22);
        if (type === 'saveALL') {
          this.$emit('success');
        } else {
          this.contractId = res.data;
          this.contractClass = 22;
          this.getDeviceList();
        }
      });
    },
    // 试用转租赁保存
    updateContractRent: function (type) {
      this.form.bizId = this.contractId;
      this.$postJSON(apis.TestToRentUpdate, this.form).then((res) => {
        if (type === 'saveALL') {
          this.$emit('success');
        } else {
          this.contractId = res.data;
          this.contractClass = 22;
          this.getDeviceList();
        }
      });
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.content-scheme {
  padding: 14px 24px 0;
  .sub-total{
    display: flex;
    justify-content: space-between;
    .item-title{
      margin-top: 9px;
    }
    .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  }

  table {
    border-collapse: collapse;
  }

  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*='cell'] {
    padding: 0;
  }
  .tab-wrap {
    // padding: 0 24px;
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;
      }
    }
    .rent-amount {
      background: #ffffff;
      padding: 0 8px;
      display: flex;
      li {
        width: 100px;
        margin: 20px 16px 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        height: 50px;
        .title {
          height: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
          line-height: 16px;
        }
        .amount {
          margin-top: 6px;
          height: 28px;
          font-size: 12px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }
}
</style>
